import TieredMenu from 'primevue/tieredmenu'
import Menu from 'primevue/menu'
// import 'primevue/resources/themes/saga-blue/theme.css'
import '@/assets/css/themes/saga-invoize-theme.css'
import '@/assets/css/themes/saga-invoize-dark-theme.css'
import '@/assets/css/themes/saga-invoize-static-theme.css'
import '@/assets/css/themes/saga-invoize-static-dark-theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import '@/assets/css/primevue-invoize.css'

export default {
  install (Vue) {
    Vue.component('TieredMenu', TieredMenu)
    Vue.component('Menu', Menu)
  }
}
